export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue) {
    // https://documentation.b2c.commercecloud.salesforce.com/DOC1/index.jsp?topic=%2Fcom.demandware.dochelp%2FDWAPI%2Fscriptapi%2Fhtml%2Fapi%2Fclass_dw_web_Resource.html&resultof=%22%52%65%73%6f%75%72%63%65%22%20%22%72%65%73%6f%75%72%63%22%20&anchor=dw_web_Resource_msg_String_String_String_DetailAnchor
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$msg = function $msg(key, bundleName = 'messages', ...values) {
      const text = window.messages[bundleName][key] ?? key;
      if (Array.isArray(values) && values.length > 0) {
        return text.replace(/{(\d+)}/g, (match, number) => (typeof values[number] !== 'undefined' ? values[number] : match));
      }
      return text;
    };
  },
};
